import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useLandingPage } from "../context/LandingPageContext";
import { fallbackTerms, fallbackPrivacy } from "../constants/constants";

const LegalDialog = ({ open, onClose, type }) => {
  const { landingData, loading } = useLandingPage();

  const content =
  type === "terms"
    ? landingData?.termsAndConditions?.content || fallbackTerms
    : landingData?.privacyPolicy?.content || fallbackPrivacy;



  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {type === "terms" ? "Terms & Conditions" : "Privacy Policy"}
      </DialogTitle>

      <DialogContent dividers sx={{ minHeight: 400 }}>
        {loading ? (
          <CircularProgress />
        ) : content ? (
          <Typography
            component="div"
            sx={{
              fontSize: "15px",
              lineHeight: 1.8,

              "& h1, & h2, & h3, & h4, & h5, & h6": {
                fontWeight: 700,
                color: "#1B3B2B",
                mt: 2,
                mb: 1,
              },

              "& p": {
                mb: 1.5,
              },

              "& ul, & ol": {
                pl: 3,
                mb: 2,
              },

              "& li": {
                mb: 1,
              },

              "& strong": {
                fontWeight: 700,
              },
            }}
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        ) : (
          <Typography>Unable to load content.</Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LegalDialog;
